import React from 'react';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { CustomerPortalProvider } from './contexts/CustomerPortalContext';
import { LanguageProvider } from './contexts/LanguageContext';
import PermissionsRevokedBanner from './components/ui/PermissionsRevokedBanner';
import { ReadOnlyProvider } from './components/ui/ReadOnlyGuard';
import BillingSessionTracker from './components/BillingSessionTracker';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <CustomerPortalProvider>
          <ReadOnlyProvider>
            <BillingSessionTracker />
            <PermissionsRevokedBanner />
            <Routes />
          </ReadOnlyProvider>
        </CustomerPortalProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
